// Currency + tier helpers (frontend-only)

export const usd = (n) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(n || 0);

export const usd2 = (n) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 }).format(n || 0);

export const nok = (n) =>
  new Intl.NumberFormat('nb-NO', { style: 'currency', currency: 'NOK', maximumFractionDigits: 0 }).format(n || 0);

const TIER_KEY = 'stan_tier';

export const getTier = () => {
  try { return localStorage.getItem(TIER_KEY) || 'free'; } catch { return 'free'; }
};

export const setTier = (tier) => {
  try { localStorage.setItem(TIER_KEY, tier); } catch {}
};

// Platform fee: 9% on Free, 0% on Pro
export const platformFeeRate = (tier) => (tier === 'pro' ? 0 : 0.09);
